import { render, staticRenderFns } from "./AgenciaObjetivoImport.vue?vue&type=template&id=dcde6978"
import script from "./AgenciaObjetivoImport.vue?vue&type=script&lang=js"
export * from "./AgenciaObjetivoImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports